/**
 * plugins/pinia.ts
 *
 * Pinia store configuration
 */

import { createPinia } from 'pinia'

export default createPinia()
